import { ReactNode } from 'react'
import { useLocation } from 'react-router-dom'

import ChunkLoadErrorBoundary from './ChunkLoadErrorBoundary.component'

type Props = {
  children: ReactNode
}

/** Chunk-load boundary that clears its recovery screen on route navigation. */
const RouteChunkErrorBoundary = ({ children }: Props) => {
  const { pathname } = useLocation()

  return (
    <ChunkLoadErrorBoundary resetKey={pathname}>
      {children}
    </ChunkLoadErrorBoundary>
  )
}

export default RouteChunkErrorBoundary
